module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "title",
    attrs: {
      "id": "tp01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageiv"
    }
  }, [_c('h2', {
    staticClass: "titlePageTitle"
  }, [_vm._v("Mysterious Skin")]), _vm._v(" "), _c('p', {
    staticClass: "titlePageText"
  }, [_vm._v("A Novel")]), _vm._v(" "), _c('h2', {
    staticClass: "titlePageAuthor"
  }, [_vm._v("Scott Heim")]), _vm._v(" "), _c('p', {
    staticClass: "titlePageLogo"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "logo.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "pageiv"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-681a1618","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780061737190_title.vue
// module id = 60
// module chunks = 0